import { createLogger } from "../../utils";
const logger = createLogger("native-helpers");
function fireClickTrackingPixel(src, parent, id) {
    const pixel = new Image();
    pixel.src = src;
    pixel.height = 0;
    pixel.width = 0;
    pixel.style.display = "none";
    pixel.onload = () => {
        parent.removeChild(pixel);
    };
    pixel.id = id ?? "";
    parent.insertBefore(pixel, parent.firstChild);
}
function handleNativeClick(event, adObject, targetElement) {
    const { native } = adObject;
    if (event.target instanceof HTMLElement) {
        const jwControlsE = targetElement.querySelector(".jw-controls");
        if (jwControlsE && jwControlsE.contains(event.target)) {
            logger.logInfo(`Click on JW control, skip pixel`);
        }
        else {
            if (native.clickTrackers) {
                native.clickTrackers.forEach((ct) => fireClickTrackingPixel(ct, window.document.body));
            }
            window.open(native.clickUrl, "_blank");
        }
    }
}
function attachClickTracker(adobject, wrapperId, videoElementId) {
    const targetE = window.document.getElementById(adobject.targetId);
    logger.logInfo(`Native click tracker attach for ${adobject}-${wrapperId}-${videoElementId}`);
    if (!targetE) {
        logger.logError(`Cannot find div for ${adobject.targetId}`);
        return;
    }
    targetE.onclick = (e) => handleNativeClick(e, adobject, targetE);
}
const titleLimit = 80;
function addTemplate(template) {
    return { ...template, name: template.name };
}
export { titleLimit, addTemplate, attachClickTracker, fireClickTrackingPixel };
//# sourceMappingURL=native-helpers.js.map